/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef, useEffect } from "react";
import { useGLTF, useTexture } from "@react-three/drei";
import model from "./Galpao_V5.glb";
import espacoDiffuse from "./materials/Espaco_Diffuse.jpg";
import lonaDiffuse from "./materials/Lona_Diffuse.jpg";
import tubulacaoCentralDiffuse from "./materials/TubulacaoCentral_Diffuse.jpg";
import tubulacaoCentralRoughness from "./materials/TubulacaoCentral_Roughness.jpg";
import tubulacaoTransversalDiffuse from "./materials/TubulacaoTransversal_Diffuse.jpg";
import tubulacaoTransversalRoughness from "./materials/TubulacaoTransversal_Roughness.jpg";

export default function Model({ ...props }) {
  const group = useRef();
  const { nodes, materials } = useGLTF(model);
  const espacoDiffuseTexture = useTexture(espacoDiffuse);
  const lonaDiffuseTexture = useTexture(lonaDiffuse);
  const tubulacaoCentralDiffuseTexture = useTexture(tubulacaoCentralDiffuse);
  const tubulacaoCentralRoughnessTexture = useTexture(
    tubulacaoCentralRoughness
  );
  const tubulacaoTransversalDiffuseTexture = useTexture(
    tubulacaoTransversalDiffuse
  );
  const tubulacaoTransversalRoughnessTexture = useTexture(
    tubulacaoTransversalRoughness
  );

  useEffect(() => {
    Object.entries(materials).forEach(([key, value]) => {
      value.envMapIntensity = props.envMapIntensity;
    });
  }, [materials, props.envMapIntensity]);

  return (
    <group ref={group} {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Espaco"
          geometry={nodes.Espaco.geometry}
          material={materials.Espaco}
          material-map={espacoDiffuseTexture}
          material-map-flipY={false}
          position={[0, 2, 0]}
        />
        <mesh
          name="EstruturaTelhado"
          geometry={nodes.EstruturaTelhado.geometry}
          material={materials.EstruturaTelhado}
          position={[-0.2, 4.75, 0.51]}
        />
        <mesh
          name="TubulacaoCentral"
          geometry={nodes.TubulacaoCentral.geometry}
          material={materials.TubulacaoCentral}
          material-map={tubulacaoCentralDiffuseTexture}
          material-map-flipY={false}
          material-roughnessMap={tubulacaoTransversalRoughnessTexture}
          material-roughnessMap-flipY={false}
          material-roughness={0.25}
          material-metalness={1}
          position={[-0.52, 4.3, -3.44]}
          scale={0.31}
        />
        <mesh
          name="TubulacaoTransversal"
          geometry={nodes.TubulacaoTransversal.geometry}
          material={materials.TubulacaoTransversal}
          material-map={tubulacaoTransversalDiffuseTexture}
          material-map-flipY={false}
          material-roughnessMap={tubulacaoTransversalRoughnessTexture}
          material-roughnessMap-flipY={false}
          material-roughness={0.8}
          material-metalness={1}
          position={[-6.75, 2.65, -3.66]}
        />
        <mesh
          name="Portico"
          geometry={nodes.Portico.geometry}
          material={materials.Portico}
          position={[-7.11, 1.8, -7.17]}
        />
        <mesh
          name="EstruturaMetalicaLateral"
          geometry={nodes.EstruturaMetalicaLateral.geometry}
          material={materials.EstruturaMetalicaLateral}
          position={[7.53, 3.1, -7.17]}
        />
        <mesh
          name="Luminarias"
          geometry={nodes.Luminarias.geometry}
          material={materials.Luminarias}
          position={[4.95, 3.88, -7.14]}
        />
        <mesh
          name="QuadroComando"
          geometry={nodes.QuadroComando.geometry}
          material={materials.QuadroComando}
          position={[-7.75, 1.3, -2]}
          rotation={[0, Math.PI / 2, 0]}
          scale={0.52}
        />
        <mesh
          name="Lona"
          geometry={nodes.Lona.geometry}
          material={materials.Lona}
          material-map={lonaDiffuseTexture}
          material-map-flipY={false}
          position={[0, 4.52, 0.56]}
        />
        <mesh
          name="Telhado"
          geometry={nodes.Telhado.geometry}
          material={materials.Telhado}
          position={[0, 6.08, 0.56]}
        />
        <mesh
          name="LenteLuminaria"
          geometry={nodes.LenteLuminaria.geometry}
          material={materials.LenteLuminaria}
          position={[4.95, 3.88, -7.14]}
        />
      </group>
    </group>
  );
}

useGLTF.preload(model);
